import { render, staticRenderFns } from "./courseCategories.vue?vue&type=template&id=a0500b40"
import script from "./courseCategories.vue?vue&type=script&lang=js"
export * from "./courseCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports